import { JobGroupBy, JobViewFilters, JobViewType, PagingOptions, SortJobOptions } from '../../entities';

export enum JobViewRequestReturnType {
    Refiners = 'Refiners',
    Count = 'Count'
}

export interface JobViewRequest {
    viewId: string;
    widgetId?: string;
    currentUserId?: string;
    refinements?: JobViewFilters;
    sort?: SortJobOptions;
    paging?: PagingOptions;
    groupBy?: JobGroupBy;
    viewType?: JobViewType;
    displayType?: string;
    returnWorkOrdersOnly?: boolean;
    returnOnly?: JobViewRequestReturnType;
    requireCount?: boolean;
}


